import { NgModule, APP_INITIALIZER }  from '@angular/core';
import { BrowserModule }              from '@angular/platform-browser';
import { FormsModule }                from '@angular/forms';
import { HttpModule, RequestOptions } from '@angular/http';

import { AUTH_PROVIDERS } from 'angular2-jwt';

import { AppRoutingModule } from './app-routing.module';

import { AppConfig } from './app.config';

import { AppComponent }           from './app.component';
import { LoginComponent }         from './login/login.component';
import { DashboardComponent }     from './dashboard/dashboard.component';

import { UsersComponent }         from './users/users.component';
import { UserDetailComponent }    from './users/detail/user-detail.component';
import { UserSearchComponent }    from './users/search/user-search.component';



import { DoctorsComponent }       from './doctors/doctors.component';
import { DoctorDetailComponent }  from './doctors/detail/doctor-detail.component';
import { DoctorCallDetailComponent }  from './doctors/detail/doctor-call-detail.component';
import { DoctorSearchComponent }  from './doctors/search/doctor-search.component';

import { AdminsComponent }        from './admins/admins.component';
import { AdminDetailComponent }   from './admins/detail/admin-detail.component';
import { AdminSearchComponent }   from './admins/search/admin-search.component';

import { PatientsComponent }      from './patients/patients.component';
import { PatientDetailComponent } from './patients/detail/patient-detail.component';
import { PatientSearchComponent } from './patients/search/patient-search.component';
import { PatientAuthDetailComponent } from './patients/detail/patient-auth-detail.component';
import { LastPatientsComponent } from './patients/lastPatients/last-patients.component';

import { MigrationsComponent } from './migrations/migrations.component';
import { PharmaciesComponent } from './pharmacies/pharmacies.component';



import { PlansComponent }      from './plans/plans.component';
import { PlanDetailComponent } from './plans/detail/plan-detail.component';
import { PlanSearchComponent } from './plans/search/plan-search.component';

import { HolidaysComponent }      from './holidays/holidays.component';
import { CallsComponent }      from './calls/calls.component';
import { AllCallsComponent }      from './calls/allCalls.component';
import { StatusCallsComponent }      from './calls/statusCalls.component';
import { DiagnosisCallsComponent }      from './calls/diagnosisCalls.component';

import { CallDetailComponent } from './calls/detail/call-detail.component';

import { HourCallsComponent }      from './calls/hourCall.component';
import { CreateCallComponent }      from './calls/createCall.component';


import { Auth }           from './services/auth.service';
import { RequestService } from './services/request.service';
import { UserService }    from './services/users/user.service';
import { DoctorService }  from './services/doctors/doctor.service';
import { AdminService }   from './services/admins/admin.service';
import { PatientService } from './services/patients/patient.service';
import { PlanService } from './services/plans/plan.service';
import { CountryService } from './services/country/country.service';
import { CallService } from './services/calls/call.service';
import { ReportService } from './services/reports/report.service';
import { SpecialtiesService } from './services/specialties/specialties.service';
import { FilterService } from './services/calls/filter.service';

import { PharmaciesService } from './services/pharmacies/pharmacies.service';


import { MigrationsService } from './services/migrations/migrations.service';
import { LoginAttemptService }  from './services/loginAttempts/loginAttempts.service';



import { HolidayService } from './services/holidays/holiday.service';
import { Authorized }     from './services/activators/authorized.service';
import { NotLoggedIn }    from './services/activators/not-logged-in.service';
import { AppInfoService } from './services/appInfo/app-info.service';
import { ProviderService } from './services/providers/provider.service';
import { RecordsService } from './services/records/records.service';

import { PriorityService } from './services/priorities/priority.service'

import { SpecialtyProviderConfigService } from './services/specialtyProviderConfig/specialty-provider-config.service'
import { HealthInsuranceService } from './services/healthInsurance/health.insurance.service'

//Boostrap lib for ng2
import { ChartsModule } from 'ng2-charts';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import './rxjs-extensions';

import { Http } from '@angular/http';
import { provideAuth, AuthHttp, AuthConfig } from 'angular2-jwt';

import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerService } from './spinner.service';
import { ReportsComponent } from './reports/reports.component';
import { PrioritiesComponent } from './priorities/priorities.component';
import { AppsInfoComponent } from './appsInfo/appsInfo.component';
import { AppInfoComponent } from './appsInfo/app-info/app-info.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { ClipboardModule } from 'ngx-clipboard';
import { ProvidersComponent } from './providers/providers.component';
import { ProviderComponent } from './providers/provider/provider.component'
import { ParticularsComponent } from './particular/particulars.component'

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { QuillEditorModule } from 'ng2-quill-editor';
import { LoginAttemptsComponent } from './login-attempts/login-attempts.component';

import { SellerComponent } from './seller/seller.component';
import { SellerDetailComponent } from './seller/seller-detail/seller-detail.component';
import { SellerService }   from './services/sellers/seller.service';
import { PatientCallDetailComponent } from './patients/detail/patient-call-detail/patient-call-detail.component';

import { CreatePatientComponent } from './patients/create/create-patient.component'

import { DeveloperDetailComponent } from './developers/detail/developer-detail.component';
import { DeveloperSearchComponent } from './developers/search/developer-search.component';
import { DevelopersComponent } from './developers/developers.component';
import { DeveloperService } from './services/developers/developer.service';
import { ProviderLogoPriorityComponent } from './provider-logo-priority/provider-logo-priority.component';
import { MedicinesComponent } from './medicines/medicines.component';
import { MedicinesService } from './services/medicines/medicines.service';

import { SpecialtiesComponent } from './specialties/specialties.component';
import { SpecialtyComponent } from './specialties/specialty/specialty.component';
import { LocalesService } from './services/locales/locales.service';
import { SpecialtyProviderConfigComponent } from './specialty-provider-config/specialty.provider.config.component';
import { HealthInsurancesComponent } from './health-insurances/health-insurance.component';
import { CallTagsComponent } from './callTags/call-tag.component';
import { CallTagService } from './services/callTag/call.tag.service';
import { PatientValidationComponent } from './patient-validation/patient-validation.component';
import { DoctorsStatusComponent } from './doctors/detail/doctor-status.component';
import { FailedEmailComponent } from './failed-email/failed-email.component';
import { FailedEmailService } from './services/failedEmails/failed-email.service'
import { DateService } from './services/date.service';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp( new AuthConfig({}), http, options);
}

export function config2(config: AppConfig){
  return () => config.load();
}

@NgModule({

  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ChartsModule,
    TimepickerModule.forRoot(),
    ClipboardModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    QuillEditorModule
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    UsersComponent,
    UserDetailComponent,
    UserSearchComponent,
    DoctorDetailComponent,
    DoctorSearchComponent,
    DoctorsComponent,
    AdminDetailComponent,
    AdminSearchComponent,
    AdminsComponent,
    PatientsComponent,
    PatientDetailComponent,
    PatientSearchComponent,
    PatientAuthDetailComponent,
    CreatePatientComponent,
    PlansComponent,
    PlanDetailComponent,
    PlanSearchComponent,
    DoctorCallDetailComponent,
    HolidaysComponent,
    CallsComponent,
    AllCallsComponent,
    StatusCallsComponent,
    DiagnosisCallsComponent,
    LastPatientsComponent,
    HourCallsComponent,
    CreateCallComponent,
    SpinnerComponent,
    CallDetailComponent,
    AllCallsComponent,
    ReportsComponent,
    PrioritiesComponent,
    AppsInfoComponent,
    AppInfoComponent,
    ProvidersComponent,
    ProviderComponent,
    ParticularsComponent,
    MigrationsComponent,
    PharmaciesComponent,
    LoginAttemptsComponent,
    SellerComponent,
    SellerDetailComponent,
    PatientCallDetailComponent,
    DeveloperDetailComponent,
    DeveloperSearchComponent,
    DevelopersComponent,
    ProviderLogoPriorityComponent,
    MedicinesComponent,
    SpecialtiesComponent,
    SpecialtyComponent,
    SpecialtyProviderConfigComponent,
    HealthInsurancesComponent,
    CallTagsComponent,
    PatientValidationComponent,
    DoctorsStatusComponent,
    FailedEmailComponent
  ],

  providers: [
    RequestService,
    Authorized,
    NotLoggedIn,
    UserService,
    DoctorService,
    AdminService,
    PatientService,
    //{provide: LocationStrategy, useClass: HashLocationStrategy},
    PlanService,
    HolidayService,
    CallService,
    ReportService,
    SpecialtiesService,
    MigrationsService,
    FilterService,
    PharmaciesService,
    LoginAttemptService,
    AppConfig,
    DeveloperService,
    LocalesService,
    CountryService,
    {
      provide: APP_INITIALIZER,
      useFactory: config2,//(config: AppConfig) => () => config.load(),
      deps: [ AppConfig ],
      multi: true
    },
    Auth,
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [ Http, RequestOptions ]
    },
    SpinnerService,
    AppInfoService,
    ProviderService,
    RecordsService,
    PriorityService,
    SellerService,
    MedicinesService,
    SpecialtyProviderConfigService,
    HealthInsuranceService,
    CallTagService,
    FailedEmailService,
    DateService
  ],
  bootstrap: [ AppComponent,
   ]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts